import { MilestoneStatusCode } from '@bechtel/types';
import { TabList, Box } from '@bechtel/gds';
import styled, { css } from 'styled-components';
import { ActivityIconPatternProps } from './types';
// @ts-ignore: tsc declarations not recognising types/index.d.ts
import blockedPattern from '@bechtel/client-assets/dist/images/pattern-red.svg';

export const CommodityTabList = styled(TabList)`
  ${({ theme }) => css`
    border-bottom: 1px solid ${theme.colors.grey['300']};
    padding-top: ${theme.spacings['400']};
    padding-left: ${theme.spacings['500']};
    padding-right: ${theme.spacings['500']};
  `}
`;

//TODO : Handled assigned activity once backend supports it
function getPatternColor(props: ActivityIconPatternProps) {
  switch (props.status) {
    case MilestoneStatusCode.APPROVED:
      return css`
        background-color: ${({ theme }) => theme.colors.green[300]};
      `;
    case MilestoneStatusCode.REJECTED:
      return css`
        background-color: ${({ theme }) => theme.colors.purple[400]};
      `;
    case MilestoneStatusCode.CLAIMED:
      return css`
        background-color: ${({ theme }) => theme.colors.orange[300]};
      `;
    case MilestoneStatusCode.BLOCKED:
      return css`
        background-color: ${({ theme }) => theme.colors.red[400]};
        background-image: url(${blockedPattern});
        background-repeat: repeat;
        background-size: ${({ theme }) => theme.fontSizes[500]};
      `;
    default:
      css`
        background-color: ${({ theme }) => theme.colors.blue[500]};
      `;
  }
}
export const ActivityIconPattern = styled.div`
  width: 20px;
  height: 20px;
  border: 1px solid ${({ theme }) => theme.colors.bechtel.blue[800]};
  border-radius: ${({ theme }) => theme.radii[900]};
  ${getPatternColor}
`;
export const FinalActivity = styled.div`
  width: 10px;
  height: 10px;
  background: ${({ theme }) => theme.colors.bechtel.blue[700]};
  border-radius: ${({ theme }) => theme.radii[900]};
`;

export const CommentStyled = styled(Box).attrs({
  p: { sm: '450' },
})`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[100]};
    border-radius: ${theme.radii[400]};
    font-size: ${theme.fontSizes[300]};
    color: ${theme.colors.grey[600]};
    margin-top: -${theme.spacings[200]};
    font-family: ${theme.fontFamilies['graphik']};
  `}
`;

export const ArrowStyled = styled(Box).attrs({ ml: { sm: '400' } })`
  ${({ theme }) => css`
    background-color: ${theme.colors.grey[100]};
    width: 9px;
    height: 9px;
    transform: rotate(-135deg);
  `}
`;
